import { AnimatePresence } from 'framer-motion';

import { IconButton } from '@/components/atoms/iconButton';

import { RequestLanguageToggle } from './RequestLanguageToggle';
import { ResponseFormatToggle } from './ResponseFormatToggle';

import IconCircledCheck from '~/svg/IconCircledCheck.svg';
import IconCopy from '~/svg/IconCopy.svg';

type RequestResponseFooterProps = {
  activeTab: 'request' | 'response';
  requestLanguageIndex: number;
  setRequestLanguageIndex: React.Dispatch<React.SetStateAction<number>>;
  responseFormatIndex: number;
  setResponseFormatIndex: React.Dispatch<React.SetStateAction<number>>;
  copyCode: () => void;
  hasResponse: boolean;
  isCopyStatusVisible: boolean;
};

export const RequestResponseFooter = ({
  requestLanguageIndex,
  responseFormatIndex,
  setRequestLanguageIndex,
  setResponseFormatIndex,
  isCopyStatusVisible,
  hasResponse,
  copyCode,
  activeTab,
}: RequestResponseFooterProps) => {
  return (
    <div className='dark relative flex h-16 shrink-0 justify-between px-6 pb-6 pt-2'>
      <div
        className='absolute bottom-full left-0 h-6 w-full'
        style={{
          background:
            'linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(13,15,16,1))',
        }}
      />
      <div className='overflow-hidden'>
        <AnimatePresence>
          {activeTab === 'request' && (
            <RequestLanguageToggle
              selectedIndex={requestLanguageIndex}
              setSelectedIndex={setRequestLanguageIndex}
            />
          )}
        </AnimatePresence>
        <AnimatePresence>
          {activeTab === 'response' && hasResponse && (
            <ResponseFormatToggle
              selectedIndex={responseFormatIndex}
              setSelectedIndex={setResponseFormatIndex}
            />
          )}
        </AnimatePresence>
      </div>
      {(activeTab === 'request' ||
        (activeTab === 'response' && hasResponse)) && (
        <IconButton
          variant='text'
          color='secondary'
          size='s'
          onClick={copyCode}
        >
          {isCopyStatusVisible ? (
            <IconCircledCheck className='text-success-S99 h-full w-full' />
          ) : (
            <IconCopy className='h-full w-full' />
          )}
        </IconButton>
      )}
    </div>
  );
};
